import { render, staticRenderFns } from "./ResizableText.vue?vue&type=template&id=7e5d98fe&"
import script from "./ResizableText.vue?vue&type=script&lang=js&"
export * from "./ResizableText.vue?vue&type=script&lang=js&"
import style0 from "./ResizableText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e5d98fe')) {
      api.createRecord('7e5d98fe', component.options)
    } else {
      api.reload('7e5d98fe', component.options)
    }
    module.hot.accept("./ResizableText.vue?vue&type=template&id=7e5d98fe&", function () {
      api.rerender('7e5d98fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/Games/ResizableText.vue"
export default component.exports